import Splide from '@splidejs/splide';

document.addEventListener("DOMContentLoaded", function() {
  var element = document.querySelector('.hero-claim div');

  if (element) {
    var splide = new Splide(element, {
      type: 'loop',
      direction: 'ttb',
      height: '44px',
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 1500,
      pauseOnHover: false,
      pauseOnFocus: false,
      mediaQuery: 'min',
      breakpoints: {
        1023: {
          height: '49px'
        },
        1365: {
          height: '60px'
        }
      }
    });

    splide.mount();
    // splide.mount();
  }
});
